import { useEmpresaSelecionada } from '../contexts/EmpresaContext';

/**
 * Telas operacionais (dashboard, estoque, pedidos, lotes, ajustes, relatórios) ainda não
 * têm uma visão "todas as empresas" como os cadastros — precisam de uma empresa específica
 * selecionada no Navbar. Esse hook centraliza essa checagem pro super_admin.
 */
export function useExigeEmpresaEspecifica() {
  const { isSuperAdmin, idEmpresa, modoGlobal, loading, empresas } = useEmpresaSelecionada();
  const carregandoEmpresas = isSuperAdmin && loading;
  const bloqueado = isSuperAdmin && !loading && (modoGlobal || !idEmpresa);
  return { bloqueado, carregandoEmpresas, semEmpresaCadastrada: isSuperAdmin && !loading && empresas.length === 0 };
}
